import type { JSONContent } from '@tiptap/react'
import React, { useCallback, useState } from 'react'

import { FormulaEditor, FormulaEditorProps } from './FormulaEditor'

interface FormulaEditorViewProps extends Omit<FormulaEditorProps, 'content' | 'onChange'> {
    style?: React.CSSProperties
    value?: JSONContent
    onClose?: () => void
}

export const FormulaView = React.forwardRef<HTMLDivElement, FormulaEditorViewProps>(({ style, value, onClose, ...rest }, ref) => {
    const [content, setContent] = useState<JSONContent | undefined>(value)
    const handleChange = useCallback(
        (json: JSONContent | undefined) => {
            setContent(json)
        },
        [setContent]
    )

    return <FormulaEditor content={content} onChange={handleChange} onClose={onClose} {...rest} />
})
